import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import Y from "../HeaderButton/FilterButton.js";
import Z from "../HeaderButton/ResizeButton.js";
import ee from "../HeaderButton/SortButton.js";
import { dataTableInjectionKey as te } from "../interface.js";
import { isColumnSortable as O, createNextSorter as le, clampValueFollowCSSRules as ie, getColKey as re, isColumnSorting as ae, isColumnFilterable as B, isColumnResizable as se } from "../utils.js";
import oe from "./SelectionMenu.js";
import { pxfy as C } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { formatLength as j } from "../../../_utils/css/format-length.js";
import de from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/virtual-list/src/VirtualList.js";
import { happensIn as D } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/happens-in.js";
import ne from "../../../checkbox/src/Checkbox.js";
import he from "../../../ellipsis/src/Ellipsis.js";
import { defineComponent as K, inject as fe, h as t, Fragment as X } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as q } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function U(n) {
  return typeof n.title == "function" ? n.title(n) : n.title;
}
const ce = K({
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    cols: {
      type: Array,
      required: !0
    },
    width: String
  },
  render() {
    const {
      clsPrefix: n,
      id: l,
      cols: c,
      width: p
    } = this;
    return t("table", {
      style: {
        tableLayout: "fixed",
        width: p
      },
      class: `${n}-data-table-table`
    }, t("colgroup", null, c.map((u) => t("col", {
      key: u.key,
      style: u.style
    }))), t("thead", {
      "data-n-id": l,
      class: `${n}-data-table-thead`
    }, this.$slots));
  }
}), ze = K({
  name: "DataTableHeader",
  props: {
    discrete: {
      type: Boolean,
      default: !0
    }
  },
  setup() {
    const {
      mergedClsPrefixRef: n,
      scrollXRef: l,
      fixedColumnLeftMapRef: c,
      fixedColumnRightMapRef: p,
      mergedCurrentPageRef: u,
      allRowsCheckedRef: k,
      someRowsCheckedRef: T,
      rowsRef: z,
      colsRef: h,
      mergedThemeRef: S,
      checkOptionsRef: H,
      mergedSortStateRef: g,
      componentId: L,
      mergedTableLayoutRef: P,
      headerCheckboxDisabledRef: I,
      virtualScrollHeaderRef: W,
      headerHeightRef: F,
      onUnstableColumnResize: M,
      doUpdateResizableWidth: _,
      handleTableHeaderScroll: A,
      deriveNextSorter: E,
      doUncheckAll: v,
      doCheckAll: w
    } = fe(te), N = q(), $ = q({});
    function a(i) {
      const r = $.value[i];
      return r == null ? void 0 : r.getBoundingClientRect().width;
    }
    function f() {
      k.value ? v() : w();
    }
    function b(i, r) {
      if (D(i, "dataTableFilter") || D(i, "dataTableResizable") || !O(r))
        return;
      const s = g.value.find((d) => d.columnKey === r.key) || null, o = le(r, s);
      E(o);
    }
    const e = /* @__PURE__ */ new Map();
    function R(i) {
      e.set(i.key, a(i.key));
    }
    function y(i, r) {
      const s = e.get(i.key);
      if (s === void 0)
        return;
      const o = s + r, d = ie(o, i.minWidth, i.maxWidth);
      M(o, d, i, a), _(i, d);
    }
    return {
      cellElsRef: $,
      componentId: L,
      mergedSortState: g,
      mergedClsPrefix: n,
      scrollX: l,
      fixedColumnLeftMap: c,
      fixedColumnRightMap: p,
      currentPage: u,
      allRowsChecked: k,
      someRowsChecked: T,
      rows: z,
      cols: h,
      mergedTheme: S,
      checkOptions: H,
      mergedTableLayout: P,
      headerCheckboxDisabled: I,
      headerHeight: F,
      virtualScrollHeader: W,
      virtualListRef: N,
      handleCheckboxUpdateChecked: f,
      handleColHeaderClick: b,
      handleTableHeaderScroll: A,
      handleColumnResizeStart: R,
      handleColumnResize: y
    };
  },
  render() {
    const {
      cellElsRef: n,
      mergedClsPrefix: l,
      fixedColumnLeftMap: c,
      fixedColumnRightMap: p,
      currentPage: u,
      allRowsChecked: k,
      someRowsChecked: T,
      rows: z,
      cols: h,
      mergedTheme: S,
      checkOptions: H,
      componentId: g,
      discrete: L,
      mergedTableLayout: P,
      headerCheckboxDisabled: I,
      mergedSortState: W,
      virtualScrollHeader: F,
      handleColHeaderClick: M,
      handleCheckboxUpdateChecked: _,
      handleColumnResizeStart: A,
      handleColumnResize: E
    } = this, v = (a, f, b) => a.map(({
      column: e,
      colIndex: R,
      colSpan: y,
      rowSpan: i,
      isLast: r
    }) => {
      var s, o;
      const d = re(e), {
        ellipsis: m
      } = e, G = () => e.type === "selection" ? e.multiple !== !1 ? t(X, null, t(ne, {
        key: u,
        privateInsideTable: !0,
        checked: k,
        indeterminate: T,
        disabled: I,
        onUpdateChecked: _
      }), H ? t(oe, {
        clsPrefix: l
      }) : null) : null : t(X, null, t("div", {
        class: `${l}-data-table-th__title-wrapper`
      }, t("div", {
        class: `${l}-data-table-th__title`
      }, m === !0 || m && !m.tooltip ? t("div", {
        class: `${l}-data-table-th__ellipsis`
      }, U(e)) : m && typeof m == "object" ? t(he, Object.assign({}, m, {
        theme: S.peers.Ellipsis,
        themeOverrides: S.peerOverrides.Ellipsis
      }), {
        default: () => U(e)
      }) : U(e)), O(e) ? t(ee, {
        column: e
      }) : null), B(e) ? t(Y, {
        column: e,
        options: e.filterOptions
      }) : null, se(e) ? t(Z, {
        onResizeStart: () => {
          A(e);
        },
        onResize: (x) => {
          E(e, x);
        }
      }) : null), V = d in c, J = d in p, Q = f && !e.fixed ? "div" : "th";
      return t(Q, {
        ref: (x) => n[d] = x,
        key: d,
        style: [f && !e.fixed ? {
          position: "absolute",
          left: C(f(R)),
          top: 0,
          bottom: 0
        } : {
          left: C((s = c[d]) === null || s === void 0 ? void 0 : s.start),
          right: C((o = p[d]) === null || o === void 0 ? void 0 : o.start)
        }, {
          width: C(e.width),
          textAlign: e.titleAlign || e.align,
          height: b
        }],
        colspan: y,
        rowspan: i,
        "data-col-key": d,
        class: [`${l}-data-table-th`, (V || J) && `${l}-data-table-th--fixed-${V ? "left" : "right"}`, {
          [`${l}-data-table-th--sorting`]: ae(e, W),
          [`${l}-data-table-th--filterable`]: B(e),
          [`${l}-data-table-th--sortable`]: O(e),
          [`${l}-data-table-th--selection`]: e.type === "selection",
          [`${l}-data-table-th--last`]: r
        }, e.className],
        onClick: e.type !== "selection" && e.type !== "expand" && !("children" in e) ? (x) => {
          M(x, e);
        } : void 0
      }, G());
    });
    if (F) {
      const {
        headerHeight: a
      } = this;
      let f = 0, b = 0;
      return h.forEach((e) => {
        e.column.fixed === "left" ? f++ : e.column.fixed === "right" && b++;
      }), t(de, {
        ref: "virtualListRef",
        class: `${l}-data-table-base-table-header`,
        style: {
          height: C(a)
        },
        onScroll: this.handleTableHeaderScroll,
        columns: h,
        itemSize: a,
        showScrollbar: !1,
        items: [{}],
        itemResizable: !1,
        visibleItemsTag: ce,
        visibleItemsProps: {
          clsPrefix: l,
          id: g,
          cols: h,
          width: j(this.scrollX)
        },
        renderItemWithCols: ({
          startColIndex: e,
          endColIndex: R,
          getLeft: y
        }) => {
          const i = h.map((s, o) => ({
            column: s.column,
            isLast: o === h.length - 1,
            colIndex: s.index,
            colSpan: 1,
            rowSpan: 1
          })).filter(({
            column: s
          }, o) => !!(e <= o && o <= R || s.fixed)), r = v(i, y, C(a));
          return r.splice(f, 0, t("th", {
            colspan: h.length - f - b,
            style: {
              pointerEvents: "none",
              visibility: "hidden",
              height: 0
            }
          })), t("tr", {
            style: {
              position: "relative"
            }
          }, r);
        }
      }, {
        default: ({
          renderedItemWithCols: e
        }) => e
      });
    }
    const w = t("thead", {
      class: `${l}-data-table-thead`,
      "data-n-id": g
    }, z.map((a) => t("tr", {
      class: `${l}-data-table-tr`
    }, v(a, null, void 0))));
    if (!L)
      return w;
    const {
      handleTableHeaderScroll: N,
      scrollX: $
    } = this;
    return t("div", {
      class: `${l}-data-table-base-table-header`,
      onScroll: N
    }, t("table", {
      class: `${l}-data-table-table`,
      style: {
        minWidth: j($),
        tableLayout: P
      }
    }, t("colgroup", null, h.map((a) => t("col", {
      key: a.key,
      style: a.style
    }))), w));
  }
});
export {
  ze as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/TableParts/Header.js
// module id = 906
// module chunks = 41